import NetworkRequestHandler from "../../service/network/NetworkRequestHandler";
import IIntentHandler from "./IIntentHandler";

/**
 * Handler intent.
*/
class ServerIntentHandler extends IIntentHandler {

    constructor() {
        super();
        this.intentResultCallback = undefined;
    }

    async handleNetworkRequest(intent, payload, context, rootView) {
        const networkRequestHandler = new NetworkRequestHandler()
        const response = await networkRequestHandler.handleRequest(intent, payload, context);
        this.intentResultCallback(response)
    }

    processIntent = async (intent, payload, context, rootView) => {
        return new Promise((resolve, reject) => {
            this.intentResultCallback = resolve
            this.handleNetworkRequest(intent, payload, context, rootView);
        })
    }
}

export default ServerIntentHandler;